module.exports = __webpack_public_path__ + "static/banner_sp-aa41c193e2f8ef170ad878564b565644.png";